export type Juki = {
  id: number;
  name: string;
  content: string;
  start: string;
  end: string;
  belong: string;
  director: string;
  contact: string;
  status: string;
  note: string;
  juki_id: number;
  color: string;
  position: { top: number; left: number };
  active: boolean;
};
